/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { DocAddonBridge, AddonInfo, DocData, AddonListChannel } from '@tencent/td-addon-sdk-docs';
import { isSupportNativeTitleBar } from '@src/js/manager/native-titlebar-manager';
import BaseAddonHandler from './addon-handler-base';
import {
    TDWOperationType,
    TDWModuleType,
    TDWActionType,
    EventCodeType,
    TDWVer9Type,
    TDWVer11Type,
    TDWFileType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { IAddonManager } from './addon-manager.interface';
import { IAddonHandlerMobile } from '@src/slide/application/service/addon/addon-handler-mobile.interface';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { INativeTitleBarManager } from '@src/slide/application/service/native-titlebar-manager/core/interface';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';

export default class AddonHandlerMobile extends BaseAddonHandler implements IAddonHandlerMobile {
    public mobileClosePanelFlag = false;
    // 实例化
    public constructor(
        protected api: any,
        addonManager: IAddonManager,
        selectionService: ISelectionService,
        private getNativeTitlebarManager: () => INativeTitleBarManager|undefined,
    ) {
        super(api, addonManager, selectionService);
    }

    public handleMobileAddonItemClick = async (addonId) => {
        const menuAction = await DocAddonBridge.fetchAddonMenu(addonId);
        const addonName = this.addonInfoMap.get(addonId)?.name;
        // 执行 Action 拉起插件
        // @ts-ignore
        DocAddonBridge.executeMenuAction(addonId, menuAction);
        tdw({
            opername: TDWOperationType.DOC_ADDON,
            module: TDWModuleType.ADDON_LIST,
            action: TDWActionType.CLK_ADDON,
            eventcode: EventCodeType.DOC_ADDON_ADDON_LIST_CLK_ADDON,
            ver6: addonId,
            ver7: addonName,
            ver9: TDWVer9Type.DETAIL_INSERT,
            ver11: TDWVer11Type.OPEN,
            file_type: TDWFileType.SLIDE,
        });
    };

    protected getAddonHook = () => ({
        onOpen: () => {
            this.mobileClosePanelFlag = true;
            const nativeTitlebarManager = this.getNativeTitlebarManager();
            if (isSupportNativeTitleBar() && nativeTitlebarManager) {
                nativeTitlebarManager.visible = false;
            }
        },
        onClose: () => {
            this.mobileClosePanelFlag = false;
            const nativeTitlebarManager = this.getNativeTitlebarManager();
            if (isSupportNativeTitleBar() && nativeTitlebarManager) {
                nativeTitlebarManager.visible = true;
            }
        },
    });

    /**
     * 初始化插件信息列表
     * @returns
     */
    protected initAddonInfoList(): void {
        if (!(appConfigInstance.getConfig('feature.addonListMobile') ?? true)) {
            return;
        }
        this.docAddonBridge.fetchAddonList({ channel: AddonListChannel.MOBILE })
            .then((addonInfoList: AddonInfo[]) => {
                addonInfoList.forEach((addonInfo) => {
                    this.addonInfoMap.set(addonInfo.addonId, addonInfo);
                });
            })
            .catch((e) => {
                window.log.error('fetchAddonInfoList mobile error', e);
            });
    }

    protected handleFetchAddonInfoList(addonInfoList: AddonInfo[]): void {
        // window.log.info('[addon info list]', addonInfoList);
        addonInfoList.forEach((addonInfo: AddonInfo) => {
            const addonMeta: any = this.getCompatibleAddon(addonInfo);
            this.saveAddonMeta(addonMeta);
            this.saveAddonInfo(addonInfo);
        });
    }

    protected getAddonInfo(): void {
        const docData: DocData = this.getDocData();
        this.initAddonOptions(docData);
        this.initAddonInfoList();
    }
}
